/**
 * Wraps localStorage/sessionStorage so values are AES-256-CBC JSON payloads `{ iv, value }`
 * (same format as Laravel openssl_decrypt). Keys stay plaintext.
 *
 * REACT_APP_STORAGE_SECRET must be exactly 32 UTF-8 characters (AES-256 key).
 */
import { decryptString, encryptString, isStorageCryptoConfigured } from './frontend-crypto';

let installed = false;

function patchStorage(storage: Storage) {
  const setItem = storage.setItem.bind(storage);
  const getItem = storage.getItem.bind(storage);

  storage.setItem = (key: string, value: string) => {
    const enc = encryptString(String(value));
    if (enc) {
      setItem(key, enc);
    } else {
      setItem(key, String(value));
    }
  };

  storage.getItem = (key: string) => decryptString(getItem(key));
}

export function installSecureStorage(): void {
  if (installed || typeof window === 'undefined') return;

  if (!isStorageCryptoConfigured()) {
    // eslint-disable-next-line no-console
    console.warn(
      '[secure-storage] Set REACT_APP_STORAGE_SECRET to exactly 32 characters (AES-256-CBC key, same as Laravel).'
    );
    return;
  }

  patchStorage(window.localStorage);
  patchStorage(window.sessionStorage);
  installed = true;
}

installSecureStorage();
